import React from 'react'
// import { CONST } from '../../utils/CONST'
import { CONST  } from '../../utils/CONST'
import { useSelector } from 'react-redux'
import clsx from 'clsx'

export const CancelVisaStatus = ({ status }: { status: number }) => {

    const lng = useSelector((state) => (state as any).common.lng)

    let find :any = CONST.cancelVisaStatus.find((item:any) => {
        return item.id === status
    })

    const generateColor = () =>{
        switch(status){
            case 0 : return 'text-purple-800 bg-purple-100';
            case 1 :return 'text-green-200 bg-green-100 '
            case 2: return 'text-red bg-rose-100'
        }
    }
    return (
        <div className={clsx(`rounded-lg text-center py-2 text-[8px] md:text-xs w-full md:w-[86px]` , generateColor())}>
            {(find)?.[`${lng}`]}
        </div>
    )


}